<!--
 * @Description: 病情信息页协议文档
 * @Author: leeyna
 * @Date: 2021-12-16 19:43:05
 * @LastEditTime: 2021-12-16 19:59:02
 * @LastEditors: leeyna
-->
<template>
  <div class="container">
    <div class="content">
      <iframe :src="$route.query.file" width="100%" height="100%" scrolling="auto"></iframe>
    </div>
    <div class="button-area">
      <button type="button" @click="goBack">我知道了</button>
    </div>
  </div>
</template>

<script>
import bridgeService from '@/lib/dsbridgeService';

export default {
  data() {
    return {};
  },
  methods: {
    goBack() {
      const historyObj = window.history;

      if (historyObj.length <= 1 || !historyObj.state.back) {
        if (this.$isInWxMP) {
          this.$wx.miniProgram.navigateBack();
          return;
        }
        bridgeService.popViewCotroller();
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #fff;
  padding: 20px;
  height: calc(100vh - 12vh);

  .content {
    height: calc(100% - 70px);
    // padding-bottom: 70px;
  }

  .button-area {
    @include fixed-bottom(10px, 15px, 10px, 15px);

    z-index: 99999;
  }

  button {
    width: 100%;
    background: linear-gradient(151deg, #42e9a4 0%, #01bb6e 100%);
    border-radius: 25px;
    padding: 13px;

    @include font(17px, 24px, #fff, center);
  }
}
</style>
